<template>
  <v-simple-table style="background-color: #555 !important;">
    <template v-slot:default>
      <thead v-if="totalWorkingItems.length">
        <tr>
          <th colspan="6">
            <small style="font-size: 0.8em;color: #bbb;">
              已領: {{alreadyGotBonus|amountFormat}},
              未領: {{notGetBonusYet|amountFormat}},
              被領走: {{lostBonus|amountFormat}}
            </small>
          </th>
        </tr>
      </thead>
      <thead v-if="totalWorkingItems.length">
        <tr>
          <th>階段</th>
          <th>執行人員</th>
          <th>工作內容</th>
          <th>獎金</th>
          <th>實發月份</th>
          <th>核發管理員</th>
        </tr>
      </thead>
      <project-bonus-task-working-item-table-row
        v-for="(workingItem,idx) in bidingWorkingItems"
        :year="year"
        :month="month"
        :key="`biding-working-item-${workingItem.ID}`"
        :item="workingItem"
        :stage="idx == 0 ? {'title':'招標中', 'len': bidingWorkingItems.length} : null"
      />
      <project-bonus-task-working-item-table-row
        v-for="(workingItem,idx) in workingWorkingItems"
        :year="year"
        :month="month"
        :key="`working-working-item-${workingItem.ID}`"
        :item="workingItem"
        :stage="idx == 0 ? {'title':'開發中', 'len': workingWorkingItems.length} : null"
      />
    </template>
  </v-simple-table>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
import ProjectBonusTaskWorkingItemTableRow from "./project-bonus-task-working-item-table-row.vue";
import filterMixin from "@/data/filters/filter-mixin.vue";
import AppDataSetting from '@/data/app-data-setting.js'
export default {
  mixins: [filterMixin],
  components: {
    ProjectBonusTaskWorkingItemTableRow
  },
  props: {
    project: {
      project: Object,
      required: true
    },
    year: {
      project: Number,
      required: true
    },
    month: {
      project: Number,
      required: true
    }
  },
  data: () => ({}),
  computed: {
    //招標中
    bidingWorkingItems() {
      // 任務必須是自己的任務，或者負責人是自己
      var result = this.taskWorkingItems.filter(o => {
        let task = AppDataSetting.attachTaskWorkingItemTask(this, o);
        if (!task) return false;
        return (
          task.IsActive &&
          task.ProjectID == this.project.ID &&
          task.ProjectStage == "招標中" &&
          o.Status != "被拒絕" &&
          (o.UserID == this.me.ID || task.ManagerID == this.me.ID)
        );
      })
      return result.sort((o1, o2) => new Date(o1.Date) - new Date(o2.Date));
    },
    workingWorkingItems() {
      var result = this.taskWorkingItems.filter(o => {
        let task = AppDataSetting.attachTaskWorkingItemTask(this, o);
        if (!task) return false;
        return (
          task.IsActive &&
          task.ProjectID == this.project.ID &&
          task.ProjectStage == "執行中" &&
          o.Status != "被拒絕" &&
          (o.UserID == this.me.ID || task.ManagerID == this.me.ID)
        );
      })
      return result.sort((o1, o2) => new Date(o1.Date) - new Date(o2.Date));
    },
    totalWorkingItems() {
      return this.bidingWorkingItems.concat(this.workingWorkingItems);
    },
    // 已領
    alreadyGotBonus() {
      return this.totalWorkingItems
        .filter(o => o.UserID == this.me.ID)
        .filter(o => o.IssuedAt)
        .reduce((sum, o) => sum + (o.Bonus || o.Budget), 0);
    },
    // 未領
    notGetBonusYet() {
      return this.totalWorkingItems
        .filter(o => o.UserID == this.me.ID)
        .filter(o => !o.IssuedAt)
        .reduce((sum, o) => sum + (o.Bonus || o.Budget), 0);
    },
    // 被領走
    lostBonus() {
      return this.totalWorkingItems
        .filter(o => o.UserID != this.me.ID)
        .filter(o => o.IssuedAt)
        .reduce((sum, o) => sum + (o.Bonus || o.Budget), 0);
    },
    ...mapGetters(["me", "tasks", "taskWorkingItems"])
  },
  methods: {},
  created() {}
};
</script>
